import { Dialog } from "primereact/dialog";
import { Button } from "primereact/button";
import React, { useState, useRef } from "react";
import { observer } from "mobx-react";
import { EFilingCompareModalModel } from "./types/EFilingCompareModalModel";
import { PdfViewerSync, PdfViewerSyncModel } from "./components/PdfViewerSync";
import {
  PdfViewerComponent,
  Toolbar,
  Magnification,
  Navigation,
  LinkAnnotation,
  BookmarkView,
  ThumbnailView,
  Print,
  TextSelection,
  TextSearch,
  Annotation,
  FormFields,
  FormDesigner,
  Inject,
  AjaxRequestSettings,
  AjaxRequestInitiateEventArgs,
} from "@syncfusion/ej2-react-pdfviewer";

interface EFilingCompareModalShowProps {
  modalName: string;
  attachmentId: any;
  convertedAttachmentID: any;
  showTestMessage: boolean;
  supportEmailAddress: string;
  filingPacketNumber: string;
  orderNumber: string;
  caseNumber: string;
  docketType: string;
  documentName: string;
  filedDate: string;
}

export const EFilingCompareModal: React.FC<EFilingCompareModalModel> = observer(
  function (props) {
    let [_showDialog, _setShowDialog] = useState(false);
    let [_attachmentId, _setAttachmentId] = useState("");
    let [_pdfAAttachmentID, _setPdfAAttachmentID] = useState("");
    let [_serviceUrl, _setServiceUrl] = useState("");
    let [_showTestMessage, _setShowTestMessage] = useState(true);
    let [_supportEmailAddress, _setSupportEmailAddress] = useState("");
    let [_filingPacketNumber, _setFilingPacketNumber] = useState("");
    let [_orderNumber, _setOrderNumber] = useState("");
    let [_caseNumber, _setCaseNumber] = useState("");
    let [_docketType, _setDocketType] = useState("");
    let [_documentName, _setDocumentName] = useState("");
    let [_filedDate, _setFiledDate] = useState("");

    let [_modalName, _setModalName] = useState(
      "Pdf/PdfA comparison approval window"
    );
    let pdfControl1 = useRef<PdfViewerComponent>(null);
    let pdfControl2 = useRef<PdfViewerComponent>(null);

    window.Frontend.EFilingCompareModalShow = (
      showProps: EFilingCompareModalShowProps
    ) => {
      _setServiceUrl(props.AppUrl);
      _setShowDialog(true);
      _setModalName(`${showProps.modalName} compare window`);

      pdfControl1.current.addEventListener(
        "ajaxRequestInitiate",
        (e: AjaxRequestInitiateEventArgs) => {
          var json = {
            ...e.JsonData,
            attachmentId: showProps.attachmentId,
            pdfAAttachmentID: null,
            isPdfAAttachment: false,
          };
          pdfControl1.current.setJsonData(json);
        }
      );

      pdfControl2.current.addEventListener(
        "ajaxRequestInitiate",
        (e: AjaxRequestInitiateEventArgs) => {
          var json = {
            ...e.JsonData,
            attachmentId: showProps.attachmentId,
            pdfAAttachmentID: showProps.convertedAttachmentID,
            isPdfAAttachment: true,
          };
          pdfControl2.current.setJsonData(json);
        }
      );

      _setPdfAAttachmentID(showProps.convertedAttachmentID);
      _setAttachmentId(showProps.attachmentId);
      _setShowTestMessage(showProps.showTestMessage);
      _setSupportEmailAddress(showProps.supportEmailAddress);
      _setFilingPacketNumber(showProps.filingPacketNumber);
      _setOrderNumber(showProps.orderNumber);
      _setCaseNumber(showProps.caseNumber);
      _setDocketType(showProps.docketType);
      _setDocumentName(showProps.documentName);
      _setFiledDate(showProps.filedDate);

      let handlers: PdfViewerSyncModel = null;
      pdfControl1.current.addEventListener("documentLoad", () => {
        handlers = PdfViewerSync(pdfControl1.current, pdfControl2.current);
        handlers.AddHandlers();
        pdfControl1.current.magnificationModule.zoomTo(50);
      });

      pdfControl2.current.addEventListener("documentLoad", () => {
        pdfControl2.current.magnificationModule.zoomTo(50);
      });

      pdfControl1.current.addEventListener("documentUnload", () => {
        handlers.RemoveHandlers();
      });

      pdfControl1.current.ajaxRequestSettings.withCredentials = true;
      pdfControl2.current.ajaxRequestSettings.withCredentials = true;

      pdfControl1.current.load(
        `eFiling-attachment-${showProps.attachmentId}.pdf`,
        null
      );
      pdfControl2.current.load(
        `eFiling-attachment-${showProps.attachmentId}-converted.pdf`,
        null
      );
    };

    const onDialogHide = () => {
      pdfControl1.current.destroy();
      pdfControl2.current.destroy();
      _setShowDialog(false);
    };

    const footer = () => {
      return (
        <div>
        </div>
      );
    };

    const reportInvalidDocument = () => {
      const testModeMessage =
        _showTestMessage === true
          ? `THIS HAS BEEN SUBMITTED FROM A TEST APPLICATION\n\n\n\n\n`
          : "";
      const bodyText = `${testModeMessage}Filing Packet Number: ${_filingPacketNumber}\n\nOrder Number: ${_orderNumber}\n\nCase Number: ${_caseNumber}\n\nDocket Type: ${_docketType}\n\nDocument Name: ${_documentName}\n\nFiled Date: ${_filedDate}\n\n\nAdditional Details:`;
      window.open(
        `mailto:${_supportEmailAddress}?subject=eFiling Error&body=${encodeURIComponent(
          bodyText
        )}`
      );
    };

    return (
      <div>
        <Dialog
          header={_modalName}
          footer={footer}
          style={{ width: "90vw", height: "90vh", overflow: "hidden" }}
          blockScroll={true}
          visible={_showDialog}
          onHide={() => {
            onDialogHide();
          }}
        >
          <div style={{ float: "left", width: "50%", height: "95%" }}>
            <div className="text-center">
              <h4>Original Pdf</h4>
            </div>
            <PdfViewerComponent
              id="container"
              zoomMode="FitToWidth"
              ref={pdfControl1}
              documentPath=""
              serviceUrl={_serviceUrl}
              enableDownload={true}
              toolbarSettings={{
                toolbarItems: [
                  "MagnificationTool",
                  "DownloadOption",
                  "PageNavigationTool",
                  "PanTool",
                  "SelectionTool",
                ],
              }}
              style={{ height: "100%", width: "100%" }}
              height="95%"
            >
              <Inject
                services={[
                  Toolbar,
                  Magnification,
                  Navigation,
                  BookmarkView,
                  TextSelection,
                ]}
              />
            </PdfViewerComponent>
          </div>
          <div style={{ float: "left", width: "50%", height: "95%" }}>
            <div className="text-center">
              <h4>Converted PdfA</h4>
            </div>
            <PdfViewerComponent
              id="container2"
              zoomMode="FitToWidth"
              ref={pdfControl2}
              documentPath=""
              serviceUrl={_serviceUrl}
              enableDownload={true}
              toolbarSettings={{
                toolbarItems: [
                  "MagnificationTool",
                  "DownloadOption",
                  "PageNavigationTool",
                  "PanTool",
                  "SelectionTool",
                ],
              }}
              style={{ height: "100%", width: "100%" }}
              height="95%"
            >
              <Inject
                services={[
                  Toolbar,
                  Magnification,
                  Navigation,
                  BookmarkView,
                  TextSelection,
                ]}
              />
            </PdfViewerComponent>
          </div>
          <br style={{ clear: "both" }} />
        </Dialog>
      </div>
    );
  }
);
